import React, { useEffect } from 'react'
import { Route, Redirect, withRouter, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../actions'
import { isFreeSoftwarePlan } from '../../web-floor-plan/utils'
import { FREE_PLAN_RESTRICTED_PATHNAMES } from '../constants'

function PrivateRoute(props) {
    const { render, ...rest } = props
    const { token, user } = useSelector(state => state.main)
    const dispatch = useDispatch()
    const isLoggedIn = token !== null

    const location = useLocation()
    const isRestrictedByFreePlan =
        user &&
        isLoggedIn &&
        isFreeSoftwarePlan() &&
        Object.values(FREE_PLAN_RESTRICTED_PATHNAMES).some(
            prefix =>
                location.pathname === prefix ||
                location.pathname.startsWith(`${prefix}/`)
        )

    useEffect(() => {
        if (user) {
            dispatch(actions.checkRouteRequest(user.id, props.history))
        }
    }, [])

    return (
        <Route
            {...rest}
            render={props => {
                if (!isLoggedIn) {
                    return <Redirect to={{ pathname: '/' }} />
                } else if (isRestrictedByFreePlan) {
                    return <Redirect to={{ pathname: '/404' }} />
                }
                return render(props)
            }}
        />
    )
}

export default withRouter(PrivateRoute)
